import(/* webpackMode: "eager" */ "/workspace/hazcams-portal/src/app/layout.js");
